import React, { useState, useContext, useEffect } from "react";
import DataTable from "./DataTableComponent";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { services } from "../services/api";
import Button from "@mui/material/Button";
import { NotificacionContext } from "../context/notificacion_context";
import IconUI from "./ui/icon_ui";
import SchoolIcon from "@mui/icons-material/School";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  toMexico,
  onlyNumber,
  maxLengthLimitInput,
} from "../../src/utils/inputsRules";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import FormHelperText from "@mui/material/FormHelperText";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Divider, Tooltip } from "@mui/material";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import dayjs from "dayjs";
import LoaderComponent from "./LoaderComponent";
import { Checkbox, FormControlLabel } from "@mui/material";
//import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from "@mui/icons-material";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Autocomplete, createFilterOptions, InputAdornment } from "@mui/material";




import SearchIcon from "@mui/icons-material/Search";


const filter = createFilterOptions();




const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#005cbf"),
  backgroundColor: "#4A001F",
  "&:hover": {
    backgroundColor: "#4A001F",
  },
}));

const Tpp = () => {
  const [state, setState] = useState({
    open: false,
    openDetalle: false,
    periodos: [],
    profesores: [],
    talleres: [],
    talleresDisciplina: [],
    listarTPP: null,
    grupo: "",
    capacidad: "",
    precio: "",
    fecha_fin: "",
    fecha_inicio: "",
    salon: "",
    profesor: "",
    taller: "",
    periodo: "",
  });

  const [loader, setLoader] = useState(false);
  const [edicion, setEdicion] = useState(false);
  const [checked, setChecked] = useState(false);
  const [actualStatus, setActualStatus] = useState(null);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  const handleChangePeriodo = (event) => {
    setState({ ...state, periodo: event.target.value });
  };

  const handleChangeTaller = (event) => {
    setState({ ...state, taller: event.target.value });
  };

  const handleChangeProfesor = (e) => {
    // eslint-disable-next-line eqeqeq
    const nombreProfesor = state.profesores.filter(element => element.id == e.target.value);

    setState({
      ...state,
      profesor: nombreProfesor[0],
    });
  };


  const handleChangeGrupo = (event) => {
    setState({ ...state, grupo: event.target.value });
  };
  const handleChangeCapacidad = (event) => {
    setState({ ...state, capacidad: event.target.value });
  };
  const handleChangePrecio = (event) => {
    setState({ ...state, precio: event.target.value });
  };

  const handleChangeFechaInicio = (event) => {
    setState({ ...state, fecha_inicio: event.target.value });
  };

  const handleChangeFechaFin = (event) => {
    setState({ ...state, fecha_fin: event.target.value });
  };

  const handleChangeSalon = (event) => {
    setState({ ...state, salon: event.target.value });
  };

  const { showNotification } = useContext(NotificacionContext);

  const openmodal = () => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      openDetalle: false,
      grupo: "",
      capacidad: "",
      precio: "",
      fecha_fin: "",
      fecha_inicio: "",
      salon: "",
      profesor: "",
      taller: "",
      periodo: "",
    }));
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      open: false,
      openDetalle: false,
      grupo: "",
      capacidad: "",
      precio: "",
      fecha_fin: "",
      fecha_inicio: "",
      salon: "",
      profesor: "",
      taller: "",
      periodo: "",
    }));
  };

  const openmodalDetalle = (talleres) => {
    setState((prevState) => ({ ...prevState, openDetalle: true, talleresDisciplina: talleres }));
    setChecked(false);
    setOpen(false);
  };

  const handleCloseDetalle = () => {
    setState((prevState) => ({
      ...prevState,
      openDetalle: false,
      grupo: "",
      capacidad: "",
      precio: "",
      fecha_fin: "",
      fecha_inicio: "",
      salon: "",
      profesor: "",
      taller: "",
      periodo: "",
    }));
    setEdicion(false);
  };

  const subirTaller = async () => {
    if (validar()) {
      setLoader(true);
      const payload = new FormData();
      payload.append("id_profesor", state.profesor);
      payload.append("id_taller", state.taller);
      payload.append("id_periodo", state.periodo);
      payload.append("grupo", state.grupo);
      payload.append("precio", state.precio);
      payload.append("capacidad", state.capacidad);
      payload.append("fechaincrpcioninicio", state.fecha_inicio);
      payload.append("fechaincrpcionfin", state.fecha_fin);
      payload.append("salon", state.salon);

      const dataTPP = await services(
        "POST",
        "usuarios/crearperiodostalleres",
        payload
      );
      if (dataTPP.status === 200) {
        const resp = dataTPP.data;

        if (resp.created === true) {

          showNotification("success", resp.mensaje, "", null, 4);
          await getListaTPP();
          handleClose();
          setLoader(false);
        } else if (resp.crear === false) {

          showNotification(
            "error",
            resp.error,
            "",
            null,
            4
          );
          setLoader(false);
        } else {

          showNotification(
            "warning",
            "Respuesta inesperada del servidor",
            "",
            null,
            4
          );
          setLoader(false);
        }
      }


    }
  };

  const getListaTPP = async () => {
    const dataPeriodos = await services("GET", "usuarios/listarperiodos", null);
    const dataProfesores = await services(
      "POST",
      "usuarios/listarusuarios?tipo=Profesor",
      null
    );
    const dataTalleres = await services("GET", "usuarios/listartalleres", null);
    const dataListarTPP = await services(
      "GET",
      "usuarios/listarperiodostallers"
    );

    setState((prevState) => ({
      ...prevState,
      periodos: dataPeriodos.data,
      profesores: dataProfesores.data,
      talleres: dataTalleres.data,
      listarTPP: dataListarTPP.data,
      openDetalle: false,
      open: false,
      grupo: "",
      capacidad: "",
      precio: "",
      fecha_fin: "",
      fecha_inicio: "",
      salon: "",
      error: "",
    }));
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getListaTPP();
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  const validar = () => {
    let profesor = state.profesor;
    let taller = state.taller;
    let periodo = state.periodo;
    let grupo = state.grupo;
    let salon = state.salon;
    let capacidad = state.capacidad;
    let precio = state.precio;
    let fecha_inicio = state.fecha_inicio;
    let fecha_fin = state.fecha_fin;

    if (
      !periodo ||
      !taller ||
      !profesor ||
      !grupo ||
      !salon ||
      !capacidad ||
      !precio ||
      !fecha_inicio ||
      !fecha_fin
    ) {
      setState({ ...state, error: "Todos los campos son requeridos" });
      return false;
    } else if (!fecha_inicio || !fecha_fin) {
      if (!fecha_inicio) {
        setState({ ...state, error: "Selecciona una fecha inicio" });
      } else if (!fecha_fin) {
        setState({ ...state, error: "Selecciona una fecha final" });
      }
      return false;
    } else {
      setState({ ...state, error: "" });
      return true;
    }
  };

  const columns = [
    {
      name: "disciplina",
      label: "Disciplina",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let disciplina = state.listarTPP[dataIndex].disciplina;
          return (
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {disciplina}
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Acciones",

      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? " d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              <Tooltip title="Ver Detalles">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    let talleres = state.listarTPP[dataIndex].talleres;
                    openmodalDetalle(talleres);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <RemoveRedEyeIcon />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];
  const [modalClone, setClone] = useState(false);
  const openModalClone = () => {
    setClone(true);
  };
  const handleCloseClone = () => {
    setClone(false);
    setDataClone({
      periodoI: "",
      periodoF: "",
      fechaI: "",
      fechaF: "",
    });
  };

  const [dataClone, setDataClone] = useState({
    periodoI: "",
    periodoF: "",
    fechaI: "",
    fechaF: "",
  });

  const handleChangeClone = ({ target }) => {
    const { name, value } = target;
    setDataClone({ ...dataClone, [name]: value });
  };

  const getClone = async () => {
    let periodoI = dataClone.periodoI;
    let periodoF = dataClone.periodoF;
    let fechaI = dataClone.fechaI;
    let fechaF = dataClone.fechaF;

    if (periodoI === "" || periodoF === "" || fechaI === "" || fechaF === "") {
      showNotification("error", "La informacion no puede ir vacía", "", null);
    } else {
      setLoader(true);
      const payload = new FormData();
      payload.append("id_periodoanterior", dataClone.periodoI);
      payload.append("fecha_inicio", dataClone.fechaI);
      payload.append("fecha_fin", dataClone.fechaF);
      payload.append("id_periodonew", dataClone.periodoF);

      let data = await services(
        "POST",
        "usuarios/clonar",
        payload
      );

      if (data.status === 200) {
        await getListaTPP();
        handleCloseClone();
        showNotification("success", "Taller(es) Duplicado(s)", "", null);
      } else {
        showNotification(
          "error",
          "Algo salio mal, intenta mas tarde",
          "",
          null
        );
      }
      setLoader(false)
    }
  };

  const guardarEdicion = async (id, idTaller, idperiodo) => {
    setLoader(true)
    const response = await services(
      "POST",
      `usuarios/editarperiodostallers/${id}`,
      {
        id_taller: idTaller,
        id_profesor: state.profesor.id,
        grupo: state.grupo,
        precio: state.precio,
        capacidad: state.capacidad,
        salon: state.salon,
        fechaincrpcioninicio: state.fecha_inicio,
        fechaincrpcionfin: state.fecha_fin,
        id_periodo: idperiodo,
        estatus: actualStatus ? 1 : 0,
      }
    );

    if (response.status === 200) {
      handleCloseDetalle();
      await getListaTPP();
      showNotification("success", "Datos del taller actualizados", "", null);
    } else {
      showNotification("error", "Algo salio mal, intenta mas tarde", "", null);
    }
    setLoader(false)
  };

  const handleCheck = (event, state) => {
    const estatus = event.target.checked;
    if (estatus) {
      setActualStatus(state !== 1 ? true : false);
    }
    setChecked(estatus);
  };



  return (
    <div style={{ height: "calc(90vh)" }}>
      {loader && <LoaderComponent />}
      {state.listarTPP ? (
        <div>
          <div className="container ">
            <Grid sx={{ marginTop: 3 }} container spacing={2}>
              <Grid className="mt-4" align="center" item xs={12} sm={6} md={6}>
                <div
                  style={{ width: 300 }}
                  className="cta cta--guinda"
                  onClick={() => {
                    openModalClone();
                  }}
                >
                  <div className="me-2">
                    <IconUI size={"20px"} color={"white"}>
                      <FileCopyIcon />
                    </IconUI>
                  </div>
                  Duplicar
                </div>
              </Grid>
              <Grid className="mt-4" align="center" item xs={12} sm={6} md={6}>
                <div
                  style={{ width: 300 }}
                  className="cta cta--guinda"
                  onClick={() => {
                    openmodal();
                  }}
                >
                  <div className="me-2">
                    <IconUI size={"20px"} color={"white"}>
                      <SchoolIcon />
                    </IconUI>
                  </div>
                  Nuevo Taller Profesor Periodo
                </div>
              </Grid>
            </Grid>
          </div>

          <DataTable
            data={state.listarTPP}
            title={"Control de Talleres Profesores Periodo"}
            columns={columns}
            more={{
              searchPlaceholder: "Buscar por Disciplina",
            }}
          />

          <Modal
            open={state.open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="boxModals">
              <Grid item xs={12} sm={12} md={12}>
                <h4>Agregar TPP</h4>
                <hr></hr>
              </Grid>
              <div className="mb-3">
                <FormControl fullWidth>
                  <InputLabel id="periodo-label">Período</InputLabel>
                  <Select
                    labelId="periodo-label"
                    id="periodo"
                    value={state.periodo || ""}
                    label="Período"
                    error={state.error}
                    onChange={handleChangePeriodo}
                  >
                    {state.periodos?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.fecha_inicio} a {item.fecha_fin} - Estatus: {item.status}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>Selecciona un Período Activo</FormHelperText>
                </FormControl>
              </div>


              <div className="mt-4">
                <Autocomplete
                  options={state.talleres}
                  getOptionLabel={(option) => option?.nombretaller || ""}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    return filtered.filter((option) =>
                      option.nombretaller.toLowerCase().includes(params.inputValue.toLowerCase())
                    );
                  }}
                  value={state.talleres.find((t) => t.id === state.taller) || null}
                  onChange={(event, newValue) => {
                    handleChangeTaller({ target: { value: newValue?.id || "" } });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Taller"
                      error={state.error}
                      helperText="Selecciona un Taller Activo"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </div>



              <div className="my-4">
                <Autocomplete
                  options={state.profesores}
                  getOptionLabel={(option) =>
                    `${option.nombre} ${option.apaterno || ""} ${option.amaterno || ""}`
                  }
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    return filtered.filter((option) => {
                      const nombreCompleto = `${option.nombre} ${option.apaterno || ""} ${option.amaterno || ""}`.toLowerCase();
                      return nombreCompleto.includes(params.inputValue.toLowerCase());
                    });
                  }}
                  value={state.profesores.find((p) => p.id === state.profesor) || null} // ✅ muestra el profesor correcto
                  onChange={(event, newValue) => {
                    setState({
                      ...state,
                      profesor: newValue ? newValue.id : "", // ✅ guarda solo el id
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Profesor"
                      error={state.error}
                      helperText="Selecciona un Profesor"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </div>




              <div className="my-4">
                <TextField
                  label="Grupo"
                  fullWidth
                  id="grupo"
                  value={state.grupo}
                  error={state.error}
                  onKeyPress={(e) => {
                    maxLengthLimitInput(e, 25, "razon_social");
                  }}
                  helperText="Ingresa un Grupo"
                  onChange={handleChangeGrupo}
                  inputProps={{ maxLength: 25 }}
                />
              </div>

              <div className="my-4">
                <TextField
                  label="Salón"
                  fullWidth
                  id="salon"
                  value={state.salon}
                  error={state.error}
                  onKeyPress={(e) => {
                    maxLengthLimitInput(e, 25, "razon_social");
                  }}
                  helperText="Ingresa un Salón"
                  onChange={handleChangeSalon}
                  inputProps={{ maxLength: 25 }}
                />
              </div>

              <div className="my-4">
                <TextField
                  label="Capacidad"
                  fullWidth
                  id="capacidad"
                  value={state.capacidad}
                  error={state.error}
                  onKeyPress={(e) => {
                    onlyNumber(e);
                  }}
                  helperText="Ingresa la cantidad de Asistentes al Taller"
                  onChange={handleChangeCapacidad}
                  inputProps={{ maxLength: 10 }}
                />
              </div>
              <div className="my-4">
                <TextField
                  label="Precio"
                  fullWidth
                  id="Precio"
                  value={state.precio}
                  error={state.error}
                  onKeyPress={(e) => {
                    onlyNumber(e);
                  }}
                  helperText="Ingresa Costo del Taller"
                  onChange={handleChangePrecio}
                  inputProps={{ maxLength: 10 }}
                />
              </div>
              <Grid
                container
                spacing={1}
                sx={{ justifyContent: "left", alignItems: "left" }}
              >
                <Grid item xs={12} sm={12} md={6}>
                  <div>Fecha de Inscripción</div>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                sx={{ justifyContent: "center", alignItems: "center" }}
              >
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="FechaInicio"
                    label="Fecha de inicio"
                    type="date"
                    variant="standard"
                    sx={{ width: "100%" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      max: state.fecha_fin || undefined,
                    }}
                    value={state.fecha_inicio}
                    helperText="Ingresa tu fecha de inicio"
                    onChange={handleChangeFechaInicio}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="FechaFin"
                    label="Fecha Fin"
                    type="date"
                    variant="standard"
                    sx={{ width: "100%" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: state.fecha_inicio || undefined,
                    }}
                    value={state.fecha_fin}
                    helperText="Ingresa tu fecha final"
                    onChange={handleChangeFechaFin}
                  />
                </Grid>
              </Grid>
              <div
                style={{ color: "red", textAlign: "center", height: "40px" }}
              >
                {state.error}
              </div>
              <Grid
                container
                spacing={2}
                className="d-flex justify-content-center align-items-center flex-md-row flex-column"
              >
                <Grid item>
                  <ColorButton
                    variant="outlined"
                    type="button"
                    endIcon={<CloseIcon />}
                    onClick={handleClose}
                  >
                    Cancelar
                  </ColorButton>
                </Grid>
                <Grid item>
                  <ColorButton
                    variant="outlined"
                    type="button"
                    endIcon={<SaveIcon />}
                    onClick={() => subirTaller()}
                  >
                    Guardar
                  </ColorButton>
                </Grid>
              </Grid>
            </div>
          </Modal>

          <Modal
            open={state.openDetalle}
            onClose={handleCloseDetalle}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="boxModals">
              <div className="mb-3">
                {state.talleresDisciplina.length !== 0 ? (
                  <>
                    <h2>{state.talleresDisciplina[0].nombredisciplina}</h2>
                    <hr></hr>
                    {state.talleresDisciplina.map((item, index) => {
                      const enEdicion = edicion === index;


                      return (
                        <>
                          <Accordion key={index}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="detalle"
                              id="detalle"
                              style={{
                                backgroundColor: "#69164a",
                                color: "white",
                              }}
                            >
                              <Typography>
                                Nombre: {item.nombretaller} - Grupo:{" "}
                                {item.grupo} - Salón: {item.salon}
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                              <table className="table table-bordered table-hover table-checkable">
                                <tbody>
                                  <tr>
                                    <td className="text-left">
                                      <b>Profesor</b>:
                                    </td>




                                    <td className="text-center">
                                      {enEdicion ? (
                                        <>
                                          <Autocomplete
                                            options={state.profesores}
                                            getOptionLabel={(option) =>
                                              `${option.nombre} ${option.apaterno || ""} ${option.amaterno || ""}`
                                            }
                                            filterOptions={(options, params) => {
                                              const filtered = filter(options, params);
                                              return filtered.filter((option) => {
                                                const nombreCompleto = `${option.nombre} ${option.apaterno || ""} ${option.amaterno || ""}`.toLowerCase();
                                                return nombreCompleto.includes(params.inputValue.toLowerCase());
                                              });
                                            }}
                                            value={state?.profesor ?? null}
                                            onChange={(event, newValue) => {
                                              handleChangeProfesor({ target: { value: newValue?.id || "" } });
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label="Profesor"
                                                error={state.error}
                                                helperText="Selecciona un Profesor"
                                                fullWidth
                                                InputProps={{
                                                  ...params.InputProps,
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      <SearchIcon />
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            )}
                                          />

                                        </>
                                      ) : (

                                        <b>
                                          {
                                            (() => {
                                              const profesor = state.profesores.find((p) => p.id === item.profesor);
                                              return profesor
                                                ? `${profesor.nombre} ${profesor.apaterno || ""} ${profesor.amaterno || ""}`
                                                : item.profesor;
                                            })()
                                          }
                                        </b>

                                      )}
                                    </td>



                                  </tr>
                                  <tr>
                                    <td className="text-left">
                                      <b>Fecha inicio inscripción:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          fullWidth
                                          margin="normal"
                                          id="FechaInicio"
                                          label="Fecha de inicio"
                                          type="date"
                                          variant="standard"
                                          sx={{ width: "100%" }}
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            max: state.fecha_fin || undefined,
                                          }}
                                          value={state.fecha_inicio}
                                          helperText="Ingresa tu fecha de inicio"
                                          onChange={handleChangeFechaInicio}
                                        />
                                      ) : (
                                        <b>{item.fechaincrpcioninicio}</b>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-left">
                                      <b>Fecha fin inscripción:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          fullWidth
                                          margin="normal"
                                          id="FechaFin"
                                          label="Fecha Fin"
                                          type="date"
                                          variant="standard"
                                          sx={{ width: "100%" }}
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            min:
                                              state.fecha_inicio || undefined,
                                          }}
                                          value={state.fecha_fin}
                                          helperText="Ingresa tu fecha final"
                                          onChange={handleChangeFechaFin}
                                        />
                                      ) : (
                                        <b>{item.fechaincrpcionfin}</b>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-left">
                                      <b>Precio:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          label="Precio"
                                          fullWidth
                                          id="Precio"
                                          value={state.precio}
                                          error={state.error}
                                          onKeyPress={(e) => {
                                            onlyNumber(e);
                                          }}
                                          helperText="Ingresa Costo del Taller"
                                          onChange={handleChangePrecio}
                                          inputProps={{ maxLength: 10 }}
                                        />
                                      ) : (
                                        <b>
                                          ${" "}
                                          {item.preciotaller
                                            ? toMexico(item.preciotaller)
                                            : "N/A"}
                                        </b>
                                      )}
                                    </td>
                                  </tr>
                                  {enEdicion ? null : (
                                    <tr>
                                      <td className="text-left">
                                        <b>Inicio de taller:</b>
                                      </td>
                                      <td className="text-center">
                                        <b>{item.inicio}</b>
                                      </td>
                                    </tr>
                                  )}

                                  {enEdicion ? null : (
                                    <tr>
                                      <td className="text-left">
                                        <b>Fin de taller:</b>
                                      </td>
                                      <td className="text-center">
                                        <b>{item.fin}</b>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td className="text-left">
                                      <b>Cupo del taller:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          label="Capacidad"
                                          fullWidth
                                          id="capacidad"
                                          value={state.capacidad}
                                          error={state.error}
                                          onKeyPress={(e) => {
                                            onlyNumber(e);
                                          }}
                                          helperText="Ingresa la cantidad de Asistentes al Taller"
                                          onChange={handleChangeCapacidad}
                                          inputProps={{ maxLength: 10 }}
                                        />
                                      ) : (
                                        <b>{item.capacidad}</b>
                                      )}
                                    </td>
                                  </tr>
                                  {enEdicion ? null : (
                                    <>
                                      <tr>
                                        <td className="text-left">
                                          <b>Edad mínima:</b>
                                        </td>
                                        <td className="text-center">
                                          <b>{item.rango}</b>
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="text-left">
                                          <b>Horario:</b>
                                        </td>
                                        <td className="text-center">
                                          <b>{item.horariotaller}</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-left">
                                          <b>Nivel:</b>
                                        </td>
                                        <td className="text-center">
                                          <b>{item.nivel}</b>
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                  <tr>
                                    <td className="text-left">
                                      <b>Salón:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          label="Salon"
                                          fullWidth
                                          id="salon"
                                          value={state.salon}
                                          error={state.error}
                                          onKeyPress={(e) => {
                                            maxLengthLimitInput(
                                              e,
                                              25,
                                              "razon_social"
                                            );
                                          }}
                                          helperText="Ingresa un Salon"
                                          onChange={handleChangeSalon}
                                          inputProps={{ maxLength: 10 }}
                                        />
                                      ) : (
                                        <b>{item.salon}</b>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-left">
                                      <b>Grupo:</b>
                                    </td>
                                    <td className="text-center">
                                      {enEdicion ? (
                                        <TextField
                                          label="Grupo"
                                          fullWidth
                                          id="grupo"
                                          value={state.grupo}
                                          error={state.error}
                                          onKeyPress={(e) => {
                                            maxLengthLimitInput(
                                              e,
                                              25,
                                              "razon_social"
                                            );
                                          }}
                                          helperText="Ingresa un Grupo1"
                                          onChange={handleChangeGrupo}
                                          inputProps={{ maxLength: 10 }}
                                        />
                                      ) : (
                                        <b>{item.grupo}</b>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-left">
                                      <b>Estatus</b>
                                    </td>

                                    <td className="text-center">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {!enEdicion ? (
                                          item.estatus === 1 ? (
                                            <span
                                              style={{
                                                color: "green",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Activo
                                            </span>
                                          ) : (
                                            <span
                                              style={{
                                                color: "red",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Inactivo
                                            </span>
                                          )
                                        ) : (
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={checked}
                                                onChange={(event) =>
                                                  handleCheck(
                                                    event,
                                                    item.estatus
                                                  )
                                                }
                                                inputProps={{
                                                  "aria-label": "controlled",
                                                }}
                                                sx={{
                                                  color: "pink",
                                                  "&.Mui-checked": {
                                                    color: "pink",
                                                  },
                                                }}
                                              />
                                            }
                                            label={
                                              item.estatus === 1
                                                ? "Desactivar"
                                                : "Activar"
                                            }
                                          />
                                        )}
                                      </div>
                                    </td>
                                  </tr>

                                  {/* <tr>
                                    <td className="text-left">
                                      <b>Cambiar Estatus</b>
                                    </td>
                                    <td className="text-center">
                                     <PoupDisable  tallerId={item.id}  />
                                    </td>
                                  </tr> */}
                                </tbody>
                              </table>
                              <div className="d-flex justify-content-end gap-2">
                                <button
                                  className="bg-rosaClaro p-2 rounded border w-25"
                                  onClick={() => {
                                    if (enEdicion) {
                                      setEdicion(false);
                                      return;
                                    }

                                    const normalizar = (str) =>
                                      str
                                        ?.normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .trim()
                                        .toLowerCase();

                                    const profEncontrado =
                                      state.profesores.find((prof) => {
                                        const nombreProf = normalizar(
                                          prof.nombre
                                        );
                                        const nombreItem = normalizar(
                                          item.profesor
                                        );
                                        return (
                                          nombreItem.includes(nombreProf) ||
                                          nombreProf.includes(nombreItem)
                                        );
                                      });

                                    setState({
                                      ...state,
                                      profesor:
                                        profEncontrado
                                      ,

                                      fecha_inicio: item.fechaincrpcioninicio,
                                      fecha_fin: item.fechaincrpcionfin,
                                      capacidad: item.capacidad,
                                      grupo: item.grupo,
                                      salon: item.salon,
                                      precio: item.preciotaller,
                                      estatus: item.estatus,
                                    });
                                    setEdicion(index);
                                  }}
                                >
                                  {enEdicion ? "Cancelar" : "Editar"}
                                </button>

                                {enEdicion ? (
                                  <>
                                    <button
                                      className=" cta--guinda p-2 rounded border w-25"
                                      variant="outlined"
                                      onClick={handleClickOpen}
                                    >
                                      Editar
                                    </button>

                                    <Dialog
                                      fullScreen={fullScreen}
                                      open={open}
                                      onClose={handleClose1}
                                      aria-labelledby="responsive-dialog-title"
                                    >
                                      <DialogContent>
                                        <DialogContentText>
                                          ¿Estás seguro de realizar esta acción?
                                        </DialogContentText>
                                      </DialogContent>
                                      <DialogActions>
                                        <button
                                          className="bg-rosaClaro p-2 rounded border w-25"
                                          autoFocus
                                          onClick={handleClose1}
                                        >
                                          Cancelar
                                        </button>

                                        <button
                                          className=" cta--guinda p-2 rounded border w-25"
                                          onClick={() =>
                                            guardarEdicion(
                                              item.id,
                                              item.idtaller,
                                              item.idperiodo
                                            )
                                          }
                                          autoFocus
                                        >
                                          Guardar
                                        </button>
                                      </DialogActions>
                                    </Dialog>
                                  </>
                                ) : /*<button
                                  className=" cta--guinda p-2 rounded border w-25"
                                  onClick={() =>
                                    guardarEdicion(
                                      item.id,
                                      item.idtaller,
                                      item.idperiodo
                                    )
                                  }
                                >
                                  Guardar
                                </button>*/
                                  null}
                                <></>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <hr></hr>
                    <h3 className="text-center">
                      Esta disciplina no cuenta con talleres activos...
                    </h3>
                    <hr></hr>
                  </>
                )}
              </div>

              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "4%",
                }}
              >
                <Grid item xs="auto"></Grid>
                <Grid item xs={5}></Grid>
                <Grid item xs="auto">
                  <ColorButton
                    variant="outlined"
                    type="button"
                    endIcon={<CloseIcon />}
                    onClick={handleCloseDetalle}
                  >
                    Cerrar
                  </ColorButton>
                </Grid>
              </Grid>
            </div>
          </Modal>

          <Modal
            open={modalClone}
            onClose={handleCloseClone}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="boxModals">
              <Grid item xs={12} sm={12} md={12}>
                <h4>Duplicar Talleres</h4>
                <hr></hr>
              </Grid>
              <div className="row mb-3">
                <div className="col-sm-6 mt-3">
                  <TextField
                    fullWidth
                    size="small"
                    select
                    label="Taller Periodo Inicial"
                    name="periodoI"
                    value={dataClone.periodoI}
                    onChange={handleChangeClone}
                  >
                    {state.periodos.map((element) => {
                      return (
                        <MenuItem key={`ìd_${element.id}_`} value={element.id}>
                          {`${element.fecha_inicio} a ${element.fecha_fin} - ${element.status}`}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
                <div className="col-sm-6 mt-3">
                  <TextField
                    fullWidth
                    size="small"
                    select
                    label="Taller Periodo Final"
                    name="periodoF"
                    value={dataClone.periodoF}
                    onChange={handleChangeClone}
                  >
                    {state.periodos.map((element) => {
                      return (
                        <MenuItem
                          key={`ìd_${element.id}_`}
                          value={element.id}
                          disabled={dataClone.periodoI === element.id}
                        >
                          {`${element.fecha_inicio} a ${element.fecha_fin} - ${element.status}`}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
                <div className="col-md-12 my-2j">
                  <Divider textAlign="left">Nuevo Periodo</Divider>
                </div>
                <div className="col-sm-6  mt-3">
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    type="date"
                    fullWidth
                    size="small"
                    label="Fecha Inscripcion Inicio"
                    onChange={handleChangeClone}
                    value={dataClone.fechaI}
                    name="fechaI"
                    inputProps={{
                      min: dayjs().format("YYYY-MM-DD"),
                    }}
                  />
                </div>
                <div className="col-sm-6  mt-3">
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    type="date"
                    fullWidth
                    size="small"
                    label="Fecha Inscripcion Final"
                    onChange={handleChangeClone}
                    value={dataClone.fechaF}
                    name="fechaF"
                    inputProps={{
                      min: dayjs().format("YYYY-MM-DD"),
                    }}
                  />
                </div>
                <div className="col-md-12  mt-3">
                  <div
                    style={{ width: "fit-content", padding: "0 9px" }}
                    className="mx-auto cta cta--guinda"
                    onClick={() => {
                      getClone(dataClone);
                    }}
                  >
                    <div className="me-2">
                      <IconUI size={"20px"} color={"white"}>
                        <SaveAsIcon />
                      </IconUI>
                    </div>
                    Guardar
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        <div style={{ height: "calc(100vh - 80px)" }}>
          <span className="loader"></span>
        </div>
      )}
    </div>
  );
};

export default Tpp;
